import type { StylePropertiesTypes } from '@wix/document-services-types'
import type { FilterFunction, FilterFunctions } from '@wix/thunderbolt-becky-root'
import {
	getStringFromConverter,
	getLengthString,
	getNumberString,
	getConverterString,
} from '../../utils/converterHelpers'

/** Internal Converters */
const numberOrLengthConverter = (value: FilterFunction['value']): string => {
	return value.type === 'Number'
		? getStringFromConverter(getNumberString(value))
		: getStringFromConverter(getLengthString(value))
}

const filterFunctionConverters = {
	blur: (value: FilterFunction['value']) => getConverterString('Length', value),
	'hue-rotate': (value: FilterFunction['value']) => getConverterString('Angle', value),
	'drop-shadow': (value: FilterFunction['value']) => getConverterString('Shadow', value),
	brightness: numberOrLengthConverter,
	contrast: numberOrLengthConverter,
	grayscale: numberOrLengthConverter,
	invert: numberOrLengthConverter,
	opacity: numberOrLengthConverter,
	saturate: numberOrLengthConverter,
	sepia: numberOrLengthConverter,
} as Record<FilterFunction['function'], (value: FilterFunction['value']) => string>

const filterFunctionConverter = (prop: FilterFunction): string => {
	const converter = filterFunctionConverters[prop.function]
	if (!converter) {
		return ''
	}

	const value = converter(prop.value)
	return `${prop.function}(${value})`
}

const filterFunctionsConverter = (prop: FilterFunctions): string => {
	return prop.functions.map(filterFunctionConverter).filter(Boolean).join(' ')
}

export const filterConverterMap = {
	FilterFunctions: filterFunctionsConverter,
} as Record<string, (prop: StylePropertiesTypes.Filter | StylePropertiesTypes.BackdropFilter) => string>
